import { ITableHeader } from '../../../components/common/Table/TypeDisplay/Desktop/TableHeader';

export const IndividualPlanHeader: ITableHeader[] = [
  { id: 1, label: 'Предмет' },
  { id: 2, label: 'Викладач' },
  { id: 3, label: 'К-ть кредитів' },
  { id: 4, label: 'К-ть аудиторних годин' },
  { id: 5, label: 'Форма контролю' },
  { id: 6, label: 'Оцінка' },
];
